import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/WhatsappIntegration/WhatsappSetup';

const WhatsappSetup = () => ((orgContainer(InnerComponent)));
export default WhatsappSetup;
